import React, { useState } from 'react'
import { Calendar } from 'primereact/calendar'
import { addLocale } from 'primereact/api'
import 'primereact/resources/themes/lara-light-indigo/theme.css' //theme
import 'primereact/resources/primereact.min.css' //core css
import 'primeicons/primeicons.css'
import './calendar-box.scss'
import { useIntl } from 'react-intl'
import AppContainer from '../../component/layout/AppContainer.tsx'

const CalendarBox = () => {
  const [today, setToday] = useState(null)
  const intl = useIntl()

  createNewLocale('es', 1, intl)

  return (
    <AppContainer className="calendarBox">
      <Calendar
        value={today}
        onChange={(e) => setToday(e.value)}
        inline
        showWeek
        locale="es"
      />
    </AppContainer>
  )
}

const createNewLocale = (localeId, firstDayOfWeek, intl) => {
  const options = {
    firstDayOfWeek,
    dayNames: [
      intl.formatMessage({ id: 'calendar.dayNames.sunday' }),
      intl.formatMessage({ id: 'calendar.dayNames.monday' }),
      intl.formatMessage({ id: 'calendar.dayNames.tuesday' }),
      intl.formatMessage({ id: 'calendar.dayNames.wednesday' }),
      intl.formatMessage({ id: 'calendar.dayNames.thursday' }),
      intl.formatMessage({ id: 'calendar.dayNames.friday' }),
      intl.formatMessage({ id: 'calendar.dayNames.saturday' }),
    ],
    dayNamesShort: [
      intl.formatMessage({ id: 'calendar.dayNamesShort.sunday' }),
      intl.formatMessage({ id: 'calendar.dayNamesShort.monday' }),
      intl.formatMessage({ id: 'calendar.dayNamesShort.tuesday' }),
      intl.formatMessage({ id: 'calendar.dayNamesShort.wednesday' }),
      intl.formatMessage({ id: 'calendar.dayNamesShort.thursday' }),
      intl.formatMessage({ id: 'calendar.dayNamesShort.friday' }),
      intl.formatMessage({ id: 'calendar.dayNamesShort.saturday' }),
    ],
    dayNamesMin: [
      intl.formatMessage({ id: 'calendar.dayNamesMin.sunday' }),
      intl.formatMessage({ id: 'calendar.dayNamesMin.monday' }),
      intl.formatMessage({ id: 'calendar.dayNamesMin.tuesday' }),
      intl.formatMessage({ id: 'calendar.dayNamesMin.wednesday' }),
      intl.formatMessage({ id: 'calendar.dayNamesMin.thursday' }),
      intl.formatMessage({ id: 'calendar.dayNamesMin.friday' }),
      intl.formatMessage({ id: 'calendar.dayNamesMin.saturday' }),
    ],
    weekHeader: intl.formatMessage({ id: 'calendar.weekHeader' }),
    monthNames: [
      intl.formatMessage({ id: 'calendar.monthNames.january' }),
      intl.formatMessage({ id: 'calendar.monthNames.february' }),
      intl.formatMessage({ id: 'calendar.monthNames.march' }),
      intl.formatMessage({ id: 'calendar.monthNames.april' }),
      intl.formatMessage({ id: 'calendar.monthNames.may' }),
      intl.formatMessage({ id: 'calendar.monthNames.june' }),
      intl.formatMessage({ id: 'calendar.monthNames.july' }),
      intl.formatMessage({ id: 'calendar.monthNames.august' }),
      intl.formatMessage({ id: 'calendar.monthNames.september' }),
      intl.formatMessage({ id: 'calendar.monthNames.october' }),
      intl.formatMessage({ id: 'calendar.monthNames.november' }),
      intl.formatMessage({ id: 'calendar.monthNames.december' }),
    ],
    monthNamesShort: [
      intl.formatMessage({ id: 'calendar.monthNamesShort.january' }),
      intl.formatMessage({ id: 'calendar.monthNamesShort.february' }),
      intl.formatMessage({ id: 'calendar.monthNamesShort.march' }),
      intl.formatMessage({ id: 'calendar.monthNamesShort.april' }),
      intl.formatMessage({ id: 'calendar.monthNamesShort.may' }),
      intl.formatMessage({ id: 'calendar.monthNamesShort.june' }),
      intl.formatMessage({ id: 'calendar.monthNamesShort.july' }),
      intl.formatMessage({ id: 'calendar.monthNamesShort.august' }),
      intl.formatMessage({ id: 'calendar.monthNamesShort.september' }),
      intl.formatMessage({ id: 'calendar.monthNamesShort.october' }),
      intl.formatMessage({ id: 'calendar.monthNamesShort.november' }),
      intl.formatMessage({ id: 'calendar.monthNamesShort.december' }),
    ],
    today: intl.formatMessage({ id: 'calendar.today' }),
    clear: intl.formatMessage({ id: 'calendar.clear' }),
  }
  addLocale(localeId, options)
}

export default CalendarBox
